import { ContactPerson, CurdDataSetConfig, FormFieldConfig, FormFieldType } from '../types';
import { ChoiceTypes } from '@mri/enums';
import { propertyCommonField } from './property-common-field';

const filterConfig: FormFieldConfig[] = [
  {
    key: 'firstName',
    label: 'Nombres',
    type: FormFieldType.STRING,
    containerClass: 'col-md-6 col-sm-6',
    optionsConfigKey: ChoiceTypes.MOBILE_TYPE
  },
  {
    key: 'lastName',
    label: 'Apellidos',
    type: FormFieldType.STRING,
    containerClass: 'col-md-6 col-sm-6',
    optionsConfigKey: ChoiceTypes.MOBILE_TYPE
  },
  {
    key: 'email',
    label: 'Correo electronico',
    type: FormFieldType.STRING,
    containerClass: 'col-md-12 col-sm-12',
    optionsConfigKey: ChoiceTypes.MOBILE_TYPE
  },
  {
    key: 'phone',
    label: 'Telefono movil',
    type: FormFieldType.STRING,
    containerClass: 'col-md-6 col-sm-6'
  },
  {
    key: 'job',
    label: 'Cargo',
    type: FormFieldType.STRING,
    containerClass: 'col-md-6 col-sm-6'
  },
  {
    ...propertyCommonField,
    type: FormFieldType.OPTIONS_MULTIPLE,
  }
];

export const contactDataSetConfig: CurdDataSetConfig<ContactPerson> = {
  entityName: 'Contacto',
  collectionName: 'Contacts',
  gatewayUrl: 'contacts',
  baseBreadcrumb: 'contacts',
  form: {
    listRedirectUrl: 'console/contacts/list',
    fields: [
      {
        key: 'firstName',
        label: 'Nombres',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6',
        optionsConfigKey: ChoiceTypes.MOBILE_TYPE
      },
      {
        key: 'lastName',
        label: 'Apellidos',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6',
        optionsConfigKey: ChoiceTypes.MOBILE_TYPE
      },
      {
        key: 'email',
        label: 'Correo electronico',
        type: FormFieldType.STRING,
        containerClass: 'col-md-12 col-sm-12',
        optionsConfigKey: ChoiceTypes.MOBILE_TYPE
      },
      {
        key: 'phone',
        label: 'Telefono movil',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6'
      },
      {
        key: 'job',
        label: 'Cargo',
        type: FormFieldType.STRING,
        containerClass: 'col-md-6 col-sm-6'
      }
    ]
  },
  list: {
    pageConfig: {
      title: 'Lista de contactos',
      breadcrumb: [
        {
          title: 'Contactos',
          type: 'item',
          link: '/console/contacts/list'
        },
        {
          title: 'Lista',
          type: 'item',
          link: '/console/contacts/list',
          pageName: 'Contactos'
        }
      ]
    },
    table: {
      columns: [
        {
          key: 'fullName', label: 'Nombre completo',
          getValue: ({ element }) => [element.firstName, element.lastName].filter(a => !!a).join(' ')
        },
        { key: 'email', label: 'Correo electronico' },
        { key: 'phone', label: 'Telefono movil' },
        { key: 'job', label: 'Cargo' },
        {
          key: 'owner', label: 'Dueño',
          getValue: ({ element }) => element.property?.name || 'No definido'
        }
      ]
    },
    actionsKeys: ['create', 'edit', 'transfer', 'delete'],
    filter: filterConfig,
    searchFilter: filterConfig
  },
  pages: ['list', 'create', 'edit']
};
